import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PersonaProviderStore } from '@sondermind/data-access/provider-facing/persona-provider';
import { SondermindApplicationService } from '@sondermind/data-access/sondermind-app-service';
import { IrisButtonContainerAlignments, IrisButtonTypes } from '@sondermind/iris/button';

@Component({
  selector: 'provider-not-accepting-clients-modal',
  templateUrl: './provider-not-accepting-clients-modal.component.html',
  styleUrls: ['./provider-not-accepting-clients-modal.component.scss'],
  standalone: false
})
export class ProviderNotAcceptingClientsModalComponent implements OnInit, OnDestroy {
  @Input() modalOpen: boolean = false;
  @Output() modalOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  irisButtonTypes = IrisButtonTypes;
  irisButtonContainerAlignments = IrisButtonContainerAlignments;

  private personaProviderId: number;

  private destroyedSubj: Subject<void> = new Subject<void>();
  destroyed$: Observable<void> = this.destroyedSubj.asObservable();

  constructor(
    private personaProviderStore: PersonaProviderStore,
    public appService: SondermindApplicationService,
  ) {}

  ngOnInit(): void {
    this.personaProviderStore.getPersonaProviderProfile$().pipe(
      takeUntil(this.destroyed$)
    ).subscribe((profile) => {
      this.personaProviderId = profile.id;
    });
  }

  stopMatching(): void {
    this.personaProviderStore.toggleSavingAvailability(true);
    this.personaProviderStore.updateAvailability$(false, this.personaProviderId).subscribe(() => {
      this.closeModal();
    });
  }

  closeModal(): void {
    this.modalOpen = false;
    this.close();
  }

  close(): void {
    this.modalOpenChange.emit(this.modalOpen);
  }

  ngOnDestroy(): void {
    this.destroyedSubj.next();
    this.destroyedSubj.complete();
  }
}
